import { Component, OnInit } from '@angular/core';
import { TabelaPrecoService } from 'src/app/services/http/tabela-preco.service';
import { distinctUntilChanged, debounceTime, startWith, first } from 'rxjs/operators';
import { FormGroup, FormControl, FormControlDirective } from '@angular/forms';
import { LoginService } from 'src/app/services/login.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-list-tabela-preco-laudo',
  templateUrl: './list-tabela-preco-laudo.component.html',
  styleUrls: ['./list-tabela-preco-laudo.component.scss']
})
export class ListTabelaPrecoLaudoComponent implements OnInit {


  listaTabelaPreco = [];
  total = 0;

  form = new FormGroup({
    id: new FormControl(''),
    nome: new FormControl(''),
    descricao: new FormControl('')
  });

  search = {
    filter: {
      id: '',
      nome: '',
      descricao: '',
    },
    sorting: {
      id: '',
      nome: 'desc',
      descricao: ''
    },
    per_page: 10,
    page: 1,
    data: new Date()
  };

  id: any;
  uuid: any;
  usuario;
  tabelaPadrao;

  first: number = 0;
  object: any = {};
  dynamicdownloadName: string = "Laudo - Tabela de Preços"

  cols: any = [
    { field: 'id', header: '#'},
    { field: 'nome', header: 'Nome' },
    { field: 'descricao', header: 'Descrição' },
  ];

  constructor(private tabelaPrecoService: TabelaPrecoService, private loginService: LoginService, private route: Router) {
  }

  ngOnInit() {
    this.loginService.getLogIn().pipe(first()).subscribe(r => this.usuario = r );
    this.tabelaPrecoService.getTabelaPadraoLaudo().then( r => this.tabelaPadrao = r.id);
    this.form.valueChanges.pipe(startWith(this.form.value), distinctUntilChanged(), debounceTime(800)).subscribe(v => {
      this.search.filter = v;
      this.getListaTabela();
    });
  }

  removerTabela(uuid) {
    this.tabelaPrecoService.excluirTabelaPrecoLaudo(uuid, 'justificativa').then(r => {
      this.getListaTabela();
    });
  }

  getListaTabela() {
    this.tabelaPrecoService.listarTabelaPrecoLaudo(this.search).then(r => {
      this.listaTabelaPreco = r.lista;
      this.total = r.total;
    });
  }

  setOrder() {
    this.getListaTabela();
  }

  setPageSize(size) {
    this.search.per_page = size;

    this.getListaTabela();
  }

  pageChange() {
    this.getListaTabela();
  }

  getTabelaPadrao() {
    this.tabelaPrecoService.getTabelaPadrao().then(r => {
      this.uuid = r['uuid'];
      if(this.id) {
        this.tabelaPrecoService.getTabelaPreco(this.uuid);
        this.route.navigate(['tabela-preco','editar', this.uuid]);
      }
    });
  }

}
